import { SearchParamsParamsContextProvider } from '@aibees/shared/hooks';
import { useMemo, type PropsWithChildren } from 'react';
import { useSearchQueryFilter } from '../../hooks/use-search-query-filter';

/**
 * Provides params (and previousParams) from the store to shared context.
 * Mount only around the search table so that param changes re-render only this subtree.
 * Must be inside SearchParamsSourceProvider (setters) and SearchParamsUrlSync.
 */
export function SearchParamsParamsProvider({ children }: PropsWithChildren) {
  const { params, previousParams } = useSearchQueryFilter();

  const value = useMemo(
    () => ({
      params,
      previousParams,
    }),
    [params, previousParams]
  );

  return (
    <SearchParamsParamsContextProvider value={value}>
      {children}
    </SearchParamsParamsContextProvider>
  );
}
